module.exports = "pegasus_template/assets/blocks/header-6-theme6.png";